import { ServiceLocation } from '@commerce-fulfillment-webcomponents/sdk';
import { AmwayShopCollections, DataTypesEnums, IpropServiceLocationAddress } from './types/propsTypes';

export const transformFulfillmentLocations = (storeData: AmwayShopCollections) =>
  storeData?.serviceLocations?.map(transformServiceLocationToShopCardData);

const transformServiceLocationToShopCardData = (serviceLocation: ServiceLocation & IpropServiceLocationAddress) => ({
  id: getValueCheck(serviceLocation.id, DataTypesEnums.TYPE_STRING),
  name: getValueCheck(serviceLocation?.name, DataTypesEnums.TYPE_STRING),
  phone: getValueCheck(serviceLocation?.phone, DataTypesEnums.TYPE_STRING),
  addressLine:
    (serviceLocation?.address &&
      `${getAddressLineExtended(serviceLocation.address?.line1, 'comma')} ${getAddressLineExtended(
        serviceLocation.address?.line2,
        'comma',
      )} ${getAddressLineExtended(serviceLocation.address?.city, 'comma')}${serviceLocation.address?.postCode}`) ||
    '',
  contact: getValueCheck(serviceLocation?.phone, DataTypesEnums.TYPE_STRING),
  allItemsAvailable: serviceLocation?.allItemsAvailable != null ? serviceLocation?.allItemsAvailable : true,
  schedule: serviceLocation?.schedule || {},
  serviceLocation: serviceLocation,
  lat: getValueCheck(Number(serviceLocation?.address.lat), DataTypesEnums.TYPE_NUMBER),
  lng: getValueCheck(Number(serviceLocation?.address.long), DataTypesEnums.TYPE_NUMBER),
});

const getValueCheck = (value?: string | number, type?: string) => {
  if (!value) {
    return type === DataTypesEnums.TYPE_STRING ? '' : 0;
  }
  return value;
};

const getAddressLineExtended = (text: string | undefined, extension: string) => {
  if (text && extension === 'comma') {
    return `${text}, `;
  }
  return '';
};
